import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { Promociones } from '@p-p-portafolio/interfaces/promociones';
import { PromocionesService } from '@p-p-portafolio/services/promociones.service';
import { SwalService } from '@shared/utils/swal.service';
import { Router } from '@angular/router';
import { SharedDataService } from '@shared/utils/shared-data.service';
import Swal from 'sweetalert2';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.css']
})
export class PromocionesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  copyForm: boolean = false;

  dataSelected: any;

  displayedColumns: Column[] = [
    { field: 'sPromocion', header: 'Promoción' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'plazoMin', header: 'Mín' },
    { field: 'plazoMax', header: 'Max' },
    { field: 'sEmpresa', header: 'Compañía' },
    { field: 'sFechaI', header: 'Fecha Inicial' },
    { field: 'sFechaF', header: 'Fecha Final' },
    { field: 'moneda', header: 'Moneda' },
    { field: 'sCartera', header: 'Tipo Cartera' },
    { field: 'actions', header: 'Acciones' }
  ];

  private readonly _width: string = '380px';
  public loading: boolean = true;
  public dataSource: Promociones[] = [];

  constructor(
    private sharedDataService: SharedDataService,
    public dialog: MatDialog,
    private _swalService: SwalService,
    private router: Router,
    private _promocionesServices: PromocionesService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.copyForm = false;
    this.loading = true;
    this._promocionesServices.read().subscribe({
      next: (response) => {
        if (response.data) {
          this.dataSource = response.data;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar promociones:', err);
        this._swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  claseCartera(claseCart: string) {
    localStorage.setItem('claseCart', claseCart);
  }

  openCreate() {
    // Limpiar sessionStorage al crear nueva promoción
    sessionStorage.removeItem('selectedPromocion');
    this.sharedDataService.updateData('');
    this.router.navigate(['/CredisystemSite/portafolio/promocion']);
  }

  openUpdate(model: Promociones) {
    // Guardar en sessionStorage para persistencia al navegar
    sessionStorage.setItem('selectedPromocion', JSON.stringify(model));
    this.sharedDataService.updateData(model);
    this.router.navigate(['/CredisystemSite/portafolio/promocion']);
  }

  select(element: Promociones) {
    if (this.dataSelected && this.dataSelected.sPromocion === element.sPromocion) {
      this.dataSelected = null;
    } else {
      this.dataSelected = element;
    }
    element.select = !element.select;
    this.dataSource.forEach((el) => {
      if (el !== element) {
        el.select = false;
      }
    });
  }

  delete(model: Promociones) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar la promoción ${model.sPromocion}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this._promocionesServices.delete(model).subscribe({
          next: (response) => {
            if (response.exito === 0) {
              this._swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this._swalService.error('No se pudo eliminar');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this._swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
